import { render, staticRenderFns } from "./human-and-animal-remains.vue?vue&type=template&id=061b96d1&"
import script from "./human-and-animal-remains.vue?vue&type=script&lang=js&"
export * from "./human-and-animal-remains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports